import { useContext } from "react";
import Checkbox from "../../Checkbox/Checkbox";
import { ConfigurationContext, DispatchContext } from "./ConfigurationContext";
import {
  isCheckboxSelected,
  isElectricalDisabled,
  isFlueDrainDisabled,
  isWoodenDisabled,
  isWaterCareDisabled,
  isElectricalVariantDisabled,
} from "./utils";
import FieldGroup from "../../FieldGroup/FieldGroup";

const FormStepAccessories = ({
  flueDrainField,
  electricalField,
  woodenField,
  waterCareField,
}) => {
  const {
    size,
    heaters: { heater },
    interiorexterior: { liner, lidCover },
    accessories: { flueDrain, electrical, wooden, waterCare },
  } = useContext(ConfigurationContext);
  const dispatch = useContext(DispatchContext);

  const handleFlueDrainChange = (option, checked) => {
    dispatch({ type: "SELECT_FLUE_DRAIN", payload: { option, checked } });
  };

  const handleElectricalChange = (option, checked) => {
    dispatch({ type: "SELECT_ELECTRICAL", payload: { option, checked } });
  };

  const handleWoodenChange = (option, checked) => {
    dispatch({ type: "SELECT_WOODEN", payload: { option, checked } });
  };

  const handleWaterCareChange = (option, checked) => {
    dispatch({ type: "SELECT_WATER_CARE", payload: { option, checked } });
  };

  const flueDrainGroupId = `${flueDrainField.name}-group`;
  const electricalGroupId = `${electricalField.name}-group`;
  const woodenGroupId = `${woodenField.name}-group`;
  const waterCareGroupId = `${waterCareField.name}-group`;

  return (
    <>
      <FieldGroup
        title={flueDrainField.title}
        id={flueDrainGroupId}
        details={flueDrainField.details}
      >
        {flueDrainField.options.map((option) => (
          <Checkbox
            key={option.id}
            name={flueDrainGroupId}
            isChecked={isCheckboxSelected(option, flueDrain)}
            isDisabled={isFlueDrainDisabled(option, heater)}
            {...option}
            onChange={handleFlueDrainChange}
          />
        ))}
      </FieldGroup>

      <FieldGroup
        title={electricalField.title}
        id={electricalGroupId}
        details={electricalField.details}
      >
        {electricalField.options.map((option) => (
          <Checkbox
            key={option.id}
            name={electricalGroupId}
            size={size}
            isChecked={isCheckboxSelected(option, electrical)}
            isDisabled={isElectricalDisabled(option, electrical, liner, size)}
            isVariantDisabled={(variant) =>
              isElectricalVariantDisabled(variant, option, electrical)
            }
            {...option}
            liner={liner}
            onChange={handleElectricalChange}
          />
        ))}
      </FieldGroup>

      <FieldGroup
        title={woodenField.title}
        id={woodenGroupId}
        details={woodenField.details}
      >
        {woodenField.options.map((option) => (
          <Checkbox
            key={option.id}
            name={woodenGroupId}
            isChecked={isCheckboxSelected(option, wooden)}
            isDisabled={isWoodenDisabled(option, liner, lidCover, size)}
            {...option}
            onChange={handleWoodenChange}
          />
        ))}
      </FieldGroup>

      <FieldGroup
        title={waterCareField.title}
        id={waterCareGroupId}
        details={waterCareField.details}
      >
        {waterCareField.options.map((option) => (
          <Checkbox
            key={option.id}
            name={waterCareGroupId}
            isChecked={isCheckboxSelected(option, waterCare)}
            isDisabled={isWaterCareDisabled(option, waterCare)}
            {...option}
            onChange={handleWaterCareChange}
          />
        ))}
      </FieldGroup>
    </>
  );
};

export default FormStepAccessories;
